var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMouseSimple = function SvgIconMouseSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7.125a1 1 0 1 0-2 0v3.75a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.125 2a6.25 6.25 0 0 0-6.25 6.25v7.5a6.25 6.25 0 0 0 6.25 6.25h3.75a6.25 6.25 0 0 0 6.25-6.25v-7.5A6.25 6.25 0 0 0 13.875 2zm-4.25 6.25A4.25 4.25 0 0 1 10.125 4h3.75a4.25 4.25 0 0 1 4.25 4.25v7.5a4.25 4.25 0 0 1-4.25 4.25h-3.75a4.25 4.25 0 0 1-4.25-4.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMouseSimple;